import React from 'react';
import { Link } from 'react-router-dom';
import { Zap, Droplets, Shield, ArrowRight } from 'lucide-react';
import PageShell from '@/components/PageShell';

const services = [
  {
    slug: 'automotive-restoration',
    icon: Zap,
    title: 'Automotive Restoration',
    cta: 'Explore automotive restoration',
    blurb:
      'Engine cases, cylinder heads, carburettors, alloy wheels and classic car components restored to factory-new condition.',
  },
  {
    slug: 'industrial-cleaning',
    icon: Droplets,
    title: 'Industrial Cleaning',
    cta: 'Read about industrial cleaning',
    blurb:
      'Remove rust, paint, scale and contaminants from production equipment, jigs, tooling and architectural fittings.',
  },
  {
    slug: 'marine-cleaning',
    icon: Shield,
    title: 'Marine Cleaning',
    cta: 'See marine cleaning services',
    blurb:
      'Strip salt corrosion from props, outboard parts, stainless fittings and hardware without pitting or warping.',
  },
];

const Services = () => (
  <PageShell
    title="Vapour Blasting Services | Wet Blasting Christchurch NZ"
    description="Specialised wet blasting services in Christchurch — automotive restoration, industrial cleaning and marine corrosion removal. Free quotes across Canterbury."
    canonicalPath="/services"
    crumbs={[{ name: 'Services', path: '/services' }]}
  >
    <section className="section-padding bg-background">
      <div className="container-wide mx-auto">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <p className="text-primary font-medium tracking-[0.3em] uppercase mb-4 text-sm">
            What We Do
          </p>
          <h1 className="font-display text-4xl md:text-5xl lg:text-6xl font-bold mb-6 text-foreground">
            Vapour Blasting <span className="gradient-text">Services</span>
          </h1>
          <p className="text-lg text-muted-foreground">
            Three core specialties, one process. Gentle wet blasting suitable for delicate alloy,
            brass and stainless components — no warping, no pitting, no surface damage. American
            workshops call it{' '}
            <Link to="/vapor-blasting" className="text-primary hover:underline">
              vapor blasting
            </Link>{' '}
            or vapor honing.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          {services.map(({ slug, icon: Icon, title, blurb, cta }) => (
            <Link
              key={slug}
              to={`/services/${slug}`}
              className="glass-card rounded-xl p-8 hover:border-primary/50 transition-colors group flex flex-col"
            >
              <div className="w-14 h-14 rounded-xl bg-primary/10 border border-primary/20 flex items-center justify-center mb-6">
                <Icon className="text-primary w-7 h-7" strokeWidth={2} />
              </div>
              <h2 className="font-display text-2xl font-bold mb-3 text-foreground group-hover:text-primary transition-colors">
                {title}
              </h2>
              <p className="text-muted-foreground mb-6 flex-1">{blurb}</p>
              <span className="inline-flex items-center gap-2 text-primary font-medium">
                {cta} <ArrowRight className="w-4 h-4 transition-transform group-hover:translate-x-1" />
              </span>
            </Link>
          ))}
        </div>

        <p className="text-center text-sm text-muted-foreground/80 mt-12 italic">
          We also offer CNC waterjet profile cutting —{' '}
          <a
            href="https://pwj.co.nz"
            target="_blank"
            rel="noopener noreferrer"
            className="text-primary/80 hover:text-primary border-b border-primary/30 hover:border-primary transition-colors not-italic"
          >
            See Precision Waterjet
          </a>{' '}
          for more information.
        </p>
      </div>
    </section>
  </PageShell>
);

export default Services;
